import APIInstance from "@/utils/apiConfig";
import { AxiosResponse } from "axios";
import { WorkBookResponse } from "@/models/workbook";

const discoveryApi = {
  getAll(): Promise<AxiosResponse<WorkBookResponse>> {
    return APIInstance.get("/workbooks");
  },
  getFull(): Promise<AxiosResponse<WorkBookResponse>> {
    return APIInstance.get("/workbooks/full");
  },
};

export default discoveryApi;
